/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CompanionsListResponse } from '../../models/companions-list-response';

export interface TravelControllerGetAllCompanions$Params {
  travel_id?: number;
  query?: string;
  limit: number;
  skip: number;
}

export function travelControllerGetAllCompanions(http: HttpClient, rootUrl: string, params: TravelControllerGetAllCompanions$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanionsListResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, travelControllerGetAllCompanions.PATH, 'get');
  if (params) {
    rb.query('travel_id', params.travel_id, {});
    rb.query('query', params.query, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: CompanionsListResponse;
      }>;
    })
  );
}

travelControllerGetAllCompanions.PATH = '/travel/companion';
